import React, { ReactElement, useState } from 'react';
import styles from './Accordion.module.css';

type Props = {
  title: ReactElement;
  children: ReactElement;
  expandedDefault?: boolean;
};

const Accordion = ({ title, children, expandedDefault }: Props) => {
  const [isExpanded, setIsExpanded] = useState(expandedDefault || false);

  return (
    <div
      className={`${styles.mainContainer} ${
        isExpanded ? styles.expanded : null
      }`}
    >
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        className={`${styles.titleContainer} ${
          isExpanded ? styles.expanded : null
        }`}
      >
        {title}
        <svg
          className={styles.icon}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M6 9l6 6l6 -6" />
        </svg>
      </div>

      <div
        className={`${styles.contentContainer} ${
          isExpanded ? styles.expanded : null
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
